export async function getList({commit}) {
  const {data} = await this.$adminRepositories.appCategories.index();
  return commit('setList', data.data);
}

export async function getListExceptId({commit}) {
  const {data} = await this.$adminRepositories.appCategories.getListExceptId();
  return commit('setListExceptId', data.data);
}

export async function deleteCategoryById({commit}, payload) {
  const response = await this.$adminRepositories.appCategories.delete(payload.id);
  await commit('removeItem', payload.index);
  return response;
}

export async function createCategory({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.appCategories.create(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function updateCategory({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$adminRepositories.appCategories.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function findCategoryById({commit}, payload) {
  const {data} = await this.$adminRepositories.appCategories.show(payload);
  return data;
}
